var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgReviewedTimecard = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15476_5992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 8.16457V8.7779C14.6645 10.2155 14.199 11.6144 13.3383 12.7658C12.4775 13.9172 11.2676 14.7596 9.88894 15.1672C8.51032 15.5748 7.03687 15.5258 5.68834 15.0276C4.33982 14.5294 3.18847 13.6086 2.406 12.4026C1.62354 11.1966 1.25189 9.76995 1.34648 8.33545C1.44107 6.90095 1.99684 5.53546 2.93088 4.44262C3.86493 3.34978 5.12722 2.58816 6.52949 2.27134C7.93176 1.95451 9.39888 2.09946 10.712 2.68457",
    stroke: "#3BB700",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.44336L8 10.1167L6 8.11669",
    stroke: "#3BB700",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15476_5992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.777344)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReviewedTimecard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reviewed-timecard.0ebf4293.svg";
export { ForwardRef as ReactComponent };